import { useLocation } from 'react-router-dom';
import { ContactSelectionMode, type ContactSelectionContext } from './types';
import { ContactViewPage } from './view';
import { ContactSingleSelectPage } from './single-select';
import { ContactMultiSelectPage } from './multi-select';

export default function ContactPage() {
  const location = useLocation();
  const selectionContext = getSelectionContext(location.state);

  switch (selectionContext.mode) {
    case ContactSelectionMode.SINGLE_CLIENT_SELECTION:
    case ContactSelectionMode.SINGLE_PROVIDER_SELECTION:
      return <ContactSingleSelectPage />;
    case ContactSelectionMode.MULTIPLE_CLIENT_SELECTION:
    case ContactSelectionMode.MULTIPLE_PROVIDER_SELECTION:
      return <ContactMultiSelectPage />;
    case ContactSelectionMode.CONTACT_VIEW:
    default:
      return <ContactViewPage />;
  }
}

function getSelectionContext(state: unknown): ContactSelectionContext {
  const context = state as ContactSelectionContext;
  if (context?.mode) {
    return context;
  }

  return {
    mode: ContactSelectionMode.CONTACT_VIEW,
  };
}
